export default __webpack_public_path__ + "static/media/tindog.3063fe6d.jpg";